import { useTranslation } from 'react-i18next';
import { DataTable, Title } from '../../../components/common';
import { useFilter } from './filter.definition';
import { useColumns } from './table.definition';
import { EntityQueryKey } from '../../../query/query.keys';
import { useActions } from './action.definition';
import { PassportService } from '../../../api/passport/passport.service';

export function PassportList() {
  const { t } = useTranslation();
  const columns = useColumns();
  const filter = useFilter();
  const [rowActions, groupActions, toolbarActions] = useActions();

  return (
    <>
      <Title text={t('passport:list.pageTitle')} />
      <DataTable
        id="passport-list"
        queryKey={EntityQueryKey.Passport}
        columns={columns}
        fetchData={PassportService.listFn}
        filter={filter}
        sortBy="lastName,firstName,secondName"
        rowActions={rowActions}
        groupActions={groupActions}
        toolbarActions={toolbarActions}
      />
    </>
  );
}